/* CRM Chrome — vanilla replacement for webflow.js nav behaviors (burger + dropdown).
   Scope: only .w-nav / .w-dropdown inside the CRM chrome sections. */
(function () {
  if (window.__crmChromeNav) return; window.__crmChromeNav = 1;

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    // ── Mobile burger: toggle the w-nav menu ──
    document.querySelectorAll('.crm-chrome-header .w-nav').forEach(function (nav) {
      var btn = nav.querySelector('.w-nav-button');
      var menu = nav.querySelector('.w-nav-menu');
      if (!btn || !menu) return;
      btn.setAttribute('role', 'button');
      btn.setAttribute('aria-expanded', 'false');
      btn.setAttribute('tabindex', '0');
      function toggle() {
        var open = nav.classList.toggle('w--open');
        btn.classList.toggle('w--open', open);
        menu.classList.toggle('w--nav-menu-open', open);
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        // Webflow shows the opened menu as an overlay under the bar
        if (open) {
          menu.style.display = 'block';
          menu.style.position = 'absolute';
          menu.style.top = '100%';
          menu.style.left = '0';
          menu.style.right = '0';
          menu.style.background = '#fff';
          menu.style.zIndex = '999';
        } else {
          menu.removeAttribute('style');
        }
      }
      btn.addEventListener('click', toggle);
      btn.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(); }
      });
      // Crossing back to desktop with the menu open left its inline overlay styles
      // stuck (menu pinned below the bar, burger display:none = unrecoverable).
      // Reset the open state whenever the viewport enters desktop range.
      var mq = window.matchMedia('(min-width: 992px)');
      function resetOnDesktop(e) { if (e.matches && nav.classList.contains('w--open')) toggle(); }
      if (mq.addEventListener) mq.addEventListener('change', resetOnDesktop);
      else if (mq.addListener) mq.addListener(resetOnDesktop);
    });

    // ── Dropdowns (DOCS): click toggles, outside click closes ──
    document.querySelectorAll('.crm-chrome-header .w-dropdown').forEach(function (dd) {
      var tgl = dd.querySelector('.w-dropdown-toggle');
      var list = dd.querySelector('.w-dropdown-list');
      if (!tgl || !list) return;
      tgl.setAttribute('role', 'button');
      tgl.setAttribute('aria-expanded', 'false');
      tgl.setAttribute('tabindex', '0');
      function setOpen(open) {
        dd.classList.toggle('w--open', open);
        list.classList.toggle('w--open', open);
        tgl.setAttribute('aria-expanded', open ? 'true' : 'false');
      }
      function toggle(e) { e.preventDefault(); setOpen(!dd.classList.contains('w--open')); }
      tgl.addEventListener('click', toggle);
      tgl.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') toggle(e);
        if (e.key === 'Escape') setOpen(false);
      });
      document.addEventListener('click', function (e) {
        if (!dd.contains(e.target)) setOpen(false);
      });
    });
  });
})();

/* Newsletter signup tracking (consent-aware). Fires GA4 newsletter_signup on submit of the
   footer newsletter form (data-crm-form="newsletter") ONLY when analytics consent is granted
   (crm_consent cookie flag or Shopify Customer Privacy). Delegated so it binds whenever the
   footer renders. Store loads crm-chrome.js (not crm-events.js), so the hook lives here too. */
(function(){
  function ok(){
    try{var c=JSON.parse(localStorage.getItem("crm_consent")||"null");if(c&&typeof c.cookie==="boolean")return c.cookie;}catch(e){}
    try{if(window.Shopify&&window.Shopify.customerPrivacy&&window.Shopify.customerPrivacy.analyticsProcessingAllowed)return window.Shopify.customerPrivacy.analyticsProcessingAllowed();}catch(e){}
    return false;
  }
  document.addEventListener("submit",function(e){
    var f=e.target;
    if(!f||!f.getAttribute||f.getAttribute("data-crm-form")!=="newsletter")return;
    if(!ok())return;
    var p={event:"newsletter_signup",method:"footer",form_id:f.id||"newsletter"};
    try{window.dataLayer=window.dataLayer||[];window.dataLayer.push(p);}catch(_){}
    if(typeof window.gtag==="function"){try{window.gtag("event","newsletter_signup",p);}catch(_){}}
  },true);
})();

/* Channel Wizard in-place on PDPs. The PDP description links /pages/channel#wizard (the
   AEO-cited deep link); instead of navigating, fetch the shared wizard block from the
   worker (/embed/page-block?name=channel-wizard — same <dialog>+JS the channel page
   composes) and open it as a modal HERE, on the store origin, where the shopper's
   crm_auth_token lives. Navigation stays as the no-JS / fetch-failure fallback, and
   /pages/channel itself is excluded — its native copy handles the hash there. */
(function(){
  if (location.pathname.indexOf('/pages/channel') === 0) return;
  var mounting = false;

  // Opened from a PDP? Preselect that product so the mint is already bound to it —
  // the picker's options load asynchronously, so poll briefly for the matching handle.
  function preselectProduct() {
    var m = location.pathname.match(/\/products\/([a-z0-9-]+)/);
    if (!m) return;
    var handle = m[1], tries = 0;
    var t = setInterval(function () {
      var sel = document.getElementById('cw-prod');
      if (sel && [].some.call(sel.options, function (o) { return o.value === handle; })) {
        sel.value = handle;
        sel.dispatchEvent(new Event('change'));
        clearInterval(t);
      } else if (++tries > 40) { clearInterval(t); }
    }, 100);
  }
  // ONE mount path, used by both the click interceptor and the #hash deep link. Previously
  // this logic lived only inside the click handler, so landing on /products/<h>#wizard did
  // nothing — there was no code listening for the hash on a PDP.
  function mountWizard(spec) {
    if (window[spec.hook]) { window[spec.hook].open(); if (spec.preselect) preselectProduct(); return; }
    if (mounting) return; mounting = true;
    fetch('https://crm-sync.dev/embed/page-block?name=' + spec.block)
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        var host = document.createElement('div');
        host.innerHTML = html;
        // innerHTML never executes <script> — re-create each one so the wizard JS runs
        host.querySelectorAll('script').forEach(function (s) {
          var n = document.createElement('script');
          n.text = s.text;
          s.parentNode.replaceChild(n, s);
        });
        document.body.appendChild(host);
        if (window[spec.hook]) window[spec.hook].open();
        if (spec.preselect) preselectProduct();
      })
      .catch(function () { if (spec.fallback) location.href = spec.fallback; })
      .finally(function () { mounting = false; });
  }

  var CHANNEL = { block: 'channel-wizard', hook: 'crmChannelWizard', preselect: true };
  var ASSET   = { block: 'asset-wizard',   hook: 'crmAssetWizard',   preselect: false };
  var KLAVIYO = { block: 'klaviyo-wizard', hook: 'crmKlaviyoWizard', preselect: false };

  document.addEventListener('click', function (e) {
    // The 3D Publisher mint wizard rides the same mount path — a PDP's wizard IS the sell,
    // so every product that has one opens it in page rather than navigating away.
    var am = e.target.closest && e.target.closest('a[href$="#mint-wizard"]');
    if (am) { e.preventDefault(); mountWizard(ASSET); return; }
    // The Klaviyo onboarding runbook, on the two Klaviyo PDPs. No page fallback because there
    // is no /pages/klaviyo to navigate to — the block IS the surface, so a fetch failure must
    // leave the visitor on the page rather than send them to a 404.
    var km = e.target.closest && e.target.closest('a[href$="#klaviyo-wizard"]');
    if (km) { e.preventDefault(); mountWizard(KLAVIYO); return; }
    var a = e.target.closest && e.target.closest('a[href*="/pages/channel#wizard"]');
    if (!a) return;
    e.preventDefault();
    mountWizard({ block: CHANNEL.block, hook: CHANNEL.hook, preselect: true, fallback: a.href });
  });

  // Hash deep links, so a shared URL or a QR opens the wizard on arrival rather than
  // silently landing on the product page. Fires on load and on subsequent hash changes.
  function fromHash() {
    if (location.hash === '#wizard') mountWizard(CHANNEL);
    else if (location.hash === '#mint-wizard') mountWizard(ASSET);
    else if (location.hash === '#klaviyo-wizard') mountWizard(KLAVIYO);
  }
  window.addEventListener('hashchange', fromHash);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fromHash);
  else fromHash();
})();
